'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinksArray = undefined;

var _reselect = require('reselect');

var _heroBanner = require('./heroBanner');

var getLinksArray = exports.getLinksArray = (0, _reselect.createSelector)([_heroBanner.getPrimaryButton, _heroBanner.getTermAndConditionsLink], function (primaryButton, termAndConditions) {
  return [termAndConditions, primaryButton];
});